import { crops, whatsappLink } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";
import { StaggerContainer, StaggerItem } from "@/components/animations/StaggerContainer";

export default function CropsSection() {
  return (
    <section className="relative py-20 md:py-28 bg-llk-cream">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <ScrollReveal>
            <p className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-llk-gold-dark mb-4">
              ATUAÇÃO
            </p>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-llk-dark font-semibold mb-4">
              Protocolos para diferentes culturas e desafios do campo
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="text-llk-dark/60 text-base md:text-lg max-w-2xl mx-auto">
              Cada cultura exige uma estratégia. A LLK atua em diferentes momentos produtivos.
            </p>
          </ScrollReveal>
        </div>

        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" staggerDelay={0.1} delayChildren={0.15}>
          {crops.map((crop) => (
            <StaggerItem key={crop.name}>
              <div className="group flex flex-col p-6 md:p-8 rounded-2xl bg-white border border-llk-earth-pale/40 transition-all duration-500 hover:shadow-lg hover:-translate-y-1 hover:border-llk-gold/30 h-full">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-llk-cream-2 flex items-center justify-center mb-4 group-hover:bg-llk-gold/10 transition-colors">
                  <i className={`${crop.icon} text-2xl md:text-3xl text-llk-gold group-hover:text-llk-gold-dark transition-colors`} />
                </div>
                <h3 className="text-lg font-semibold text-llk-dark mb-2">{crop.name}</h3>
                <p className="text-llk-dark/60 text-sm leading-relaxed">{crop.description}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>

        <ScrollReveal delay={0.3}>
          <div className="mt-10 md:mt-14 text-center">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-llk-dark text-white font-medium rounded-full hover:bg-llk-gold transition-colors"
            >
              <i className="ri-whatsapp-line" />
              Consulte para sua cultura
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}